import { useSelector } from 'react-redux';
import styled from 'styled-components';

import { WorkTaskDTO2 } from '../../../../api/api';
import { AddIcon } from '../../../../assets/icons/AddIcon';
import { TabProps } from '../../../../blocks/tabs-vertical/TabsVertical';
import Button from '../../../../components/button/Button';
import CircularProgress from '../../../../components/circular-progress/CircularProgress';
import Typography from '../../../../components/typography/Typography';
import { selectUserProfile } from '../../../../stateManagement/reducers/userProfileReducer';
import { Container, SectionHeader } from '../../../../styling/FormStyling';
import WorkPermitCard from './WorkPermitCard';

interface Props extends TabProps {
  currentTask?: WorkTaskDTO2;
  workPermits: WorkTaskDTO2[];
  isLoading: boolean;
  onCreateWorkPermit: () => void;
  onOpenWorkPermit: (workPermitTaskId: number) => void;
  onWorkPermitChanged: () => void;
}

const WorkPermitsStep = (props: Props) => {
  const { currentTask, workPermits, isLoading, onCreateWorkPermit, onOpenWorkPermit, onWorkPermitChanged } = props;
  const userDepartmentId = useSelector(selectUserProfile).userProfile?.department?.departmentId;

  return (
    <Container>
      <Header>
        <SectionHeader>Arbejdstilladelser</SectionHeader>
        <Button variant="secondary" onClick={onCreateWorkPermit}>
          <AddIcon size="20px" />
          Opret arbejdstilladelse (KOS)
        </Button>
      </Header>
      {isLoading && <CircularProgress />}
      {!isLoading && workPermits.length === 0 && <Typography>Der er ingen arbejdstilladelser på opgaven.</Typography>}
      {!isLoading && workPermits.length > 0 && (
        <Cards>
          {workPermits.map((workPermit) => (
            <WorkPermitCard
              key={workPermit.id}
              workPermit={workPermit}
              currentTask={currentTask}
              isCurrentTask={workPermit.id === currentTask?.id}
              userDepartmentId={userDepartmentId}
              onOpen={onOpenWorkPermit}
              onChanged={onWorkPermitChanged}
            />
          ))}
        </Cards>
      )}
    </Container>
  );
};

const Header = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
`;

const Cards = styled.div`
  display: flex;
  flex-direction: column;
  row-gap: 16px;
`;

export default WorkPermitsStep;
